"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyboardSpinDirection = void 0;
/**
 * {@docCategory SpinButton}
 */
var KeyboardSpinDirection;
(function (KeyboardSpinDirection) {
    KeyboardSpinDirection[KeyboardSpinDirection["down"] = -1] = "down";
    KeyboardSpinDirection[KeyboardSpinDirection["notSpinning"] = 0] = "notSpinning";
    KeyboardSpinDirection[KeyboardSpinDirection["up"] = 1] = "up";
})(KeyboardSpinDirection || (exports.KeyboardSpinDirection = KeyboardSpinDirection = {}));
//# sourceMappingURL=SpinButton.types.js.map